module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-section"
  }, [_vm._m(0), _c('div', {
    staticClass: "cards-grid"
  }, _vm._l((_vm.lista), function(item) {
    return _c('StatCard', {
      key: item.id,
      attrs: {
        "titulo": item.titulo,
        "cantidad": item.cantidad,
        "tipo": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.redirigir(item.ruta)
        }
      }
    })
  }), 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', [_vm._v("Mis pendientes")]), _c('p', [_vm._v("Actividades personales que todavía tienes por completar.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7abdeae5","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kpis/dashboard/c_mis_pendientes.vue
// module id = 919
// module chunks = 0